import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TypedFormGroup } from '@feature/forms/form-model';

@Component({
    selector: 'wai-html-content',
    templateUrl: './html-content.component.html',
    styleUrls: ['./html-content.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HtmlContentComponent {
  public asTypedFormGroup = (x: unknown): TypedFormGroup<any> => x as TypedFormGroup<any>;

  @Input() public content: string;
}
